import React, {
  createContext,
  FunctionComponent,
  PropsWithChildren,
  useContext,
  useState,
} from 'react'

import { Policy } from '../../../domain'
import { useApiErrorHandlingAsyncCallback } from '../../../hooks/auth'
import { usePrincipal } from '../../authentication'

interface PolicyContextObj {
  policy: Policy
  setPolicy: (policy: Policy) => void
  refresh: () => Promise<void>
}

const PolicyContext = createContext<PolicyContextObj | undefined>(undefined)

export interface PolicyProviderProps extends PropsWithChildren {
  policy: Policy
}

export const PolicyProvider: FunctionComponent<PolicyProviderProps> = (props) => {
  const { apiClient } = usePrincipal()

  const [policy, setPolicy] = useState(props.policy)

  const { execute: refresh } = useApiErrorHandlingAsyncCallback(async () => {
    setPolicy(await apiClient.getPolicy(policy.policyId))
  })

  return (
    <PolicyContext.Provider value={{ policy, setPolicy, refresh }}>
      {props.children}
    </PolicyContext.Provider>
  )
}

export const usePolicy = (): PolicyContextObj => {
  const context = useContext(PolicyContext)
  if (!context) {
    throw new Error('Cannot use PolicyContext when undefined.')
  }
  return context
}

export const useMaybePolicy = (): Policy | undefined => useContext(PolicyContext)?.policy
